export default {
  methods: {
    onFilePicked(e, callback) {
      let f = { name: '' }
      const files = e.target.files
      if (files[0] !== undefined) {
        f.name = files[0].name
        f.file = files[0]
        if (f.name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          f.url = fr.result
          callback(f)
        })
      }
    },
  },
}
